
import { component as VueCodeHighlight } from 'vue-code-highlight';

import FButton from '@/components/atoms/buttons/h-button';
import { useDisplaySnackbar } from '~co/useSnackbar';

export default {
  name: 'CodeSnippet',

  components: {
    VueCodeHighlight,
    FButton,
  },

  props: {
    language: {
      type: String,
      default: 'html',
    },

    code: {
      type: String,
      required: true,
    },

    singleLine: {
      type: Boolean,
    },

    caption: {
      type: String,
      default: '',
    },
  },

  methods: {
    async copyCode() {
      try {
        await navigator.clipboard.writeText(this.code);

        useDisplaySnackbar({ message: this.$t('success-message') });
      } catch (error) {
        useDisplaySnackbar({
          message: this.$t('error-message'),
          status: 'error',
          iconName: 'warning',
        });
      }
    },
  },
};
